/**
 * 開發環境 overlay 會把瀏覽器的 ResizeObserver loop 警告當成未捕捉錯誤。
 * Ant Design Select／DatePicker 搭配 PerfectScrollbar 展開時很常見，可忽略。
 */
export function suppressResizeObserverError() {
  if (typeof window === "undefined") return;

  const isResizeObserverError = (msg) =>
    typeof msg === "string" && msg.includes("ResizeObserver");

  // 攔截 window.onerror
  const originalOnError = window.onerror;
  window.onerror = function (message, source, lineno, colno, error) {
    if (isResizeObserverError(message) || isResizeObserverError(error?.message)) {
      return true; // 阻止錯誤傳播
    }
    return originalOnError?.apply(this, arguments);
  };

  // 攔截 error 事件
  window.addEventListener(
    "error",
    (event) => {
      const msg = event?.message || event?.error?.message || "";
      if (isResizeObserverError(msg)) {
        event.stopImmediatePropagation();
        event.preventDefault();
      }
    },
    true
  );

  // 攔截 unhandledrejection
  window.addEventListener(
    "unhandledrejection",
    (event) => {
      const msg = event?.reason?.message || String(event?.reason || "");
      if (isResizeObserverError(msg)) {
        event.stopImmediatePropagation();
        event.preventDefault();
      }
    },
    true
  );
}
